var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"auth-main-content"},[_c('router-view')],1),(_vm.isAuthPage)?[_c('GAuthSiteFooter')]:[_c('GSiteFooter')]],2)}
var staticRenderFns = []

export { render, staticRenderFns }